import { useSelector } from 'react-redux';
import styled from 'styled-components';

const ContactIcons = ({ isOpen = true, showTel = true, sort = 'asc' }) => {
    const { appSettings } = useSelector((state) => state.common);
    const contacts = appSettings?.contacts || [];

    if (contacts.length === 0) {
        return null;
    }

    return (
        <>
            {[...contacts]
              .sort((a, b) => sort === 'asc' ? +a.sort - +b.sort : +b.sort - +a.sort)
              .filter(contact => showTel ? true : !contact.link.includes('tel:'))
              .map((contact, idx) => (
                    <IconButton key={idx} href={contact.link} target="_blank" rel="noopener noreferrer" bgColor={contact.color} isOpen={isOpen}>
                        <img src={contact.image} alt="contact icon" width="32" height="32"/>
                    </IconButton>
                ))
            }
        </>
    );
};

export default ContactIcons;

const Button = styled.a`
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 18px;
  background-color: ${(props) => props.bgColor || '#EA394B'};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  color: #ffffff !important;
  text-decoration: none;
  transition: transform 0.3s ease, opacity 0.3s ease;
  &:hover {
    transform: scale(1.05);
    color: #ffffff;
    text-decoration: none;
  }
  @media (max-width: 798px) {
    width: 45px;
    height: 45px;
  }
`

const IconButton = styled(Button)`
  z-index: 1;
  transform: ${(props) => (props.isOpen ? 'translateX(0)' : 'translateX(100px)')};
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  user-select: none;
  @media (max-width: 798px) {
    transform: ${(props) => (props.isOpen ? 'translateY(0)' : 'translateY(-100px)')};
  }
`
